
  import { Lead, LeadActivity } from '@/entities/crm'
  import { Component, Prop, Watch } from 'vue-property-decorator'
  import { GForm } from '../../GForm'

@Component
  export default class TaskDetail extends GForm {
  @Prop({ type: Object, default: null }) info!: { lead: Lead, task: LeadActivity }

  globalInfoLead: Lead | null = null

  get purchaseNotes () {
    if (!this.info?.task) return []

    return this.info?.task?.notes?.filter(note => note.deal.type.name === 'purchase')
  }

  get saleNotes () {
    if (!this.info?.task) return []

    return this.info?.task?.notes?.filter(note => note.deal.type.name === 'sale')
  }

  @Watch('info', { immediate: true })
  async onInfoChange (val) {
    const leadId = val.task?.lead?.id || val.lead?.id

    this.globalInfoLead = await this.fetchData({
      query: { name: 'fetch', model: 'Lead', params: { id: leadId } },
      force: true,
    })
  }

  beforeDestroy () {
    this.globalInfoLead = null
  }
  }
